import { useState, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import "./Login.style.scss";
import { useRouter } from "src/hooks/useRouter";
import LoginUI from "./Login.presenter";
import { useLogIn } from "src/hooks/api/auth/useLogin";
import { getUserInfoFromLocalStorage } from "src/utils/storage/auth";
import { logout } from "src/service/sessions";
import { LoginFormData, loginSchema } from "./Login.schema";
interface ILoginContainerProps {}

const LoginContainer = () => {
  const [isShowFindPassword, setIsShowFindPassword] = useState<boolean>(false);
  const [resetPasswordTxt, setResetPasswordTxt] = useState<boolean>(false);
  const [resetPasswordBtn, setResetPasswordBtn] = useState<boolean>(false);
  const [checkForgetUserId, setCheckForgetUserId] = useState<boolean>(false);
  const [invalidUser, setInvalidUser] = useState<boolean>(false);
  const [viewStepBar, setViewStepBar] = useState<boolean>(false);
  const { currentPath, goConsole, goHome } = useRouter();

  // 로그인 폼 관리
  const loginForm = useForm<LoginFormData>({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      userId: localStorage?.getItem("potal.wrapsodyeco.com_userId") ?? "",
      password: "",
      isIdSave: localStorage.getItem("potal.wrapsodyeco.com_userId")
        ? true
        : false,
    },
    mode: "onChange",
  });
  const { setError } = loginForm;

  const { mutateLogin } = useLogIn({ setInvalidUser, setError });

  // ID 저장 체크박스 핸들러
  const handleChangeIdSave = () => {
    const currentValue = loginForm.getValues("isIdSave");
    const newValue = !currentValue;
    loginForm.setValue("isIdSave", newValue);

    const userId = loginForm.getValues("userId");
    if (newValue && userId) {
      localStorage.setItem("potal.wrapsodyeco.com_userId", userId);
    } else {
      localStorage.removeItem("potal.wrapsodyeco.com_userId");
    }
  };

  // 로그인 폼 제출 핸들러
  const onLoginSubmit = async (data: LoginFormData) => {
    try {
      await logout(true);
    } catch (error: any) {
      if (error.errorCode && error.errorMessage) {
        alert(error.errorMessage);
      }
    }
    mutateLogin({ userId: data.userId, password: data.password });
  };

  const goBackLogin = () => {
    setIsShowFindPassword(false);
  };

  const goFindPassword = () => {
    setIsShowFindPassword(true);
  };
  useEffect(() => {
    async function loginCheck() {
      const cloudUserInfo = JSON.parse(getUserInfoFromLocalStorage() as string);
      if (getUserInfoFromLocalStorage()) {
        goConsole();
      }
      // else {
      //   goHome();
      // }
      //   if ((await sessionCheck({})) === "OK") {
      //     const cloudUserInfo = JSON.parse(
      //       getUserInfoFromLocalStorage() as string
      //     );
      //     if (cloudUserInfo === null) return;
      //     if (cloudUserInfo.userInfo.loginType === "FASOO_AD") {
      //       await logout(true);
      //     } else {
      //       goConsole();
      //     }
      //   }
    }
    loginCheck();
  }, []);
  // 폼 상태에서 값들 추출
  const { userId, password, isIdSave } = loginForm.watch();
  const loginPossible = loginForm.formState.isValid && !!userId && !!password;

  // ID 저장 상태에 따른 로컬스토리지 업데이트
  useEffect(() => {
    if (isIdSave && userId) {
      localStorage.setItem("potal.wrapsodyeco.com_userId", userId);
    } else if (!isIdSave) {
      localStorage.removeItem("potal.wrapsodyeco.com_userId");
    }
  }, [userId, isIdSave]);

  return (
    <FormProvider {...loginForm}>
      <LoginUI
        // 폼 데이터
        userId={userId}
        password={password}
        isIdSave={isIdSave}
        // 상태
        isShowFindPassword={isShowFindPassword}
        loginPossible={loginPossible}
        invalidUser={invalidUser}
        // 폼 관련
        loginForm={loginForm}
        onLoginSubmit={onLoginSubmit}
        // 핸들러
        handleChangeIdSave={handleChangeIdSave}
        goBackLogin={goBackLogin}
        goFindPassword={goFindPassword}
      />
    </FormProvider>
  );
};

export default LoginContainer;
